<section id="summary">
  <mh-wait-chain *ngIf="waiting" [currentChain]="currentChain" [block]="callingInterchain" [total]="totalSizeChain" [totalBlock]="totalSizeBlock" [error]="error"></mh-wait-chain>
  <ng-container *ngIf="!waiting" >
    <widget-filter-chain [customers]="chain" (actives)="filterCustomers($event)"></widget-filter-chain>
    <mh-interchain-prestay-table [hasActiveServices]="hasActiveServices" [hasActiveWebcheckin]="hasActiveWebcheckin" [dataSource]="dataSource" [customersDetails]="customersDetails"></mh-interchain-prestay-table>
  </ng-container>

</section>
